import { WHATSAPP_URL } from './api';

export const exploreLocalities = [
  { name: 'Yamuna', city: 'Yamuna Expressway', propertyType: 'plot', badge: 'High growth corridor' },
  { name: 'Central Noida', city: 'Noida', propertyType: 'apartment', badge: 'Ready communities' },
  { name: 'Noida Expressway', city: 'Noida', propertyType: 'apartment', badge: 'Luxury inventory' },
  { name: 'Noida Extension', city: 'Noida Extension', propertyType: 'apartment', badge: 'Budget to premium' },
  { name: 'Greater Noida', city: 'Greater Noida', propertyType: 'villa', badge: 'Family living hubs' },
];

export const bankOffers = [
  { bank: 'SBI', rate: '8.35% onwards', note: 'Strong salaried buyer approval rates' },
  { bank: 'HDFC Bank', rate: '8.50% onwards', note: 'Fast digital document pickup' },
  { bank: 'ICICI Bank', rate: '8.60% onwards', note: 'Flexible balance-transfer options' },
  { bank: 'Axis Bank', rate: '8.70% onwards', note: 'Good for self-employed applicants' },
];

export const newsArticles = [
  {
    id: 'insight-1',
    title: 'Top micro-markets drawing premium demand around Noida in 2026',
    category: 'Market Trends',
    excerpt: 'A snapshot of buyer demand, expressway-led appreciation, and where premium inventory is getting absorbed faster.',
    author: 'ANK Research Desk',
    date: 'March 15, 2026',
    readTime: '5 min read',
    featured: true,
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=80'
  },
  {
    id: 'insight-2',
    title: 'How to compare home-loan offers before locking a property deal',
    category: 'Finance',
    excerpt: 'A clear framework for comparing rate type, processing fees, prepayment clauses, and sanction timelines.',
    author: 'ANK Finance Team',
    date: 'March 11, 2026',
    readTime: '4 min read',
    image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&w=1200&q=80'
  },
  {
    id: 'insight-3',
    title: 'Checklist for owners posting a property that converts faster',
    category: 'Selling Tips',
    excerpt: 'Why verified details, realistic pricing, clean photos, and a strong headline dramatically improve lead quality.',
    author: 'ANK Seller Success',
    date: 'March 8, 2026',
    readTime: '3 min read',
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1200&q=80'
  },
];

export const socialLinks = [
  { label: 'Instagram', href: 'https://www.instagram.com/', icon: 'instagram' },
  { label: 'YouTube', href: 'https://www.youtube.com/', icon: 'youtube' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/', icon: 'linkedin' },
  { label: 'WhatsApp', href: WHATSAPP_URL, icon: 'whatsapp' },
];
